import React, { useEffect } from 'react';

// Importing Components
import Header from 'components/Header.jsx';
import Footer from 'components/Footer.jsx';
import Sidebar from 'components/Sidebar.jsx';
import PageBreadcrumb from 'components/PageBreadcrumb.jsx';

// Importing Outlet
import { Outlet } from "react-router-dom";
import ScreenRecordingProvider from 'components/ScreenRecordingScheduler';

const Layout = () => {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      // Required for Chrome/Edge; custom text is ignored by modern browsers.
      event.returnValue = 'You are leaving the HR Portal. Are you sure you want to close this page?';
      return event.returnValue;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <ScreenRecordingProvider>
        <Header />
        <Sidebar />
        <main id='main' className='main'>
          <PageBreadcrumb />
          <Outlet />
        </main>
        <Footer />
    </ScreenRecordingProvider>
  )
}

export default Layout;
